const config: ConsentManagerConfig = {
    logging: true,
    consentConfig: {
        necessary: true,        // Notwendige Einträge sind immer erlaubt
        preferences: false,     // Standardmäßig deaktiviert
        statistics: false,      // Standardmäßig deaktiviert
        marketing: false,        // Standardmäßig deaktiviert
    },
    cookieItems: [],
    localStorageItems: [
        { name: 'consentConfig', category: 'necessary' }, // Zustimmungskonfiguration ist immer notwendig
        { name: 'reviews_ChIJjxnY6DYlv0cRcSzqEEZe19U', category: 'preferences' }, // Google Maps Rezensionen
        { name: 'place_rating_info', category: 'preferences' }, // Google Maps Rezensionen
    ],
    sessionStorageItems: [
        { name: 'gFunnelwebApiBaseUrl', category: 'preferences' }, // Wird von Google Maps gesetzt
        { name: 'gStreetViewBaseUrl', category: 'preferences' }, // Wird von Google Maps gesetzt
        { name: 'gBillingBaseUrl', category: 'preferences' }, // Wird von Google Maps gesetzt
        { name: 'gMapConfigsBaseUrl', category: 'preferences' }, // Wird von Google Maps gesetzt
        { name: 'gPlacesApiBaseUrl', category: 'preferences' }, // Wird von Google Maps gesetzt
        { name: 'gClearcutLoggingE2ETestId', category: 'statistics' }, // Wird von Google Maps gesetzt
        { name: 'gInternalNoCorsPreflightForTesting', category: 'statistics' }, // Wird von Google Maps gesetzt
        { name: '__sak', category: 'preferences' }, // Wird von YouTube gesetzt
    ],
    thirdPartyTools: [
        {
            name: 'Google Maps JavaScript API',
            globalVar: 'google',
            category: 'preferences', // Google Maps API erst laden, wenn Nutzer es erlaubt
            // scriptUrl: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD7pPR2FVRnoA3RMWVgUfrqc2a1lvVzAXw&libraries=marker,places',
            scriptUrl: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCfVvR_7eZvF01dSHLrMlXVRzd7GWNBgqE&libraries=marker,places',
        },
        {
            name: 'Google Maps Dynamic Scripts',
            globalVar: undefined,
            category: 'preferences',
            scriptUrl: 'https://maps.googleapis.com/',
        },
    ],
    hideBannerOnUrls: [
        '/impressum',
        '/datenschutzerklaerung',
        '/agbs',
        '/widerrufsbelehrung',
    ]
};

export default config;
